const STROKE = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
}

/** Un pictogramme identifiable par famille, à la place du disque coloré. */
export function NotificationKindIcon({ kind = 'info', size = 20 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true" focusable="false">
      {kind === 'success' ? (
        <>
          <circle cx="12" cy="12" r="9" {...STROKE} />
          <path d="M8.2 12.4l2.6 2.6 5-5.4" {...STROKE} />
        </>
      ) : null}
      {kind === 'warning' ? (
        <>
          <path d="M12 3.8L21 19.2H3z" {...STROKE} />
          <path d="M12 9.6v4.2" {...STROKE} />
          <path d="M12 16.6h.01" {...STROKE} strokeWidth="2.2" />
        </>
      ) : null}
      {kind === 'error' ? (
        <>
          <circle cx="12" cy="12" r="9" {...STROKE} />
          <path d="M9 9l6 6M15 9l-6 6" {...STROKE} />
        </>
      ) : null}
      {kind === 'info' ? (
        <>
          <circle cx="12" cy="12" r="9" {...STROKE} />
          <path d="M12 11v5.4" {...STROKE} />
          <path d="M12 7.7h.01" {...STROKE} strokeWidth="2.2" />
        </>
      ) : null}
    </svg>
  )
}

export function TrashGlyph({ size = 16 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true" focusable="false">
      <path d="M4.5 7h15" {...STROKE} />
      <path d="M9.5 7V5.4A1.4 1.4 0 0 1 10.9 4h2.2a1.4 1.4 0 0 1 1.4 1.4V7" {...STROKE} />
      <path d="M6.6 7l.8 11.1A1.9 1.9 0 0 0 9.3 20h5.4a1.9 1.9 0 0 0 1.9-1.9L17.4 7" {...STROKE} />
      <path d="M10.4 11v5M13.6 11v5" {...STROKE} />
    </svg>
  )
}

export function ClearAllGlyph({ size = 16 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true" focusable="false">
      <path d="M4 6.5h11M4 12h8M4 17.5h6" {...STROKE} />
      <path d="M15.5 15.5l5 5M20.5 15.5l-5 5" {...STROKE} />
    </svg>
  )
}

export function MarkReadGlyph({ size = 16 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true" focusable="false">
      <path d="M3 12.6l3.4 3.4L13 9" {...STROKE} />
      <path d="M11 15.4l1.6 1.6L21 8.6" {...STROKE} />
    </svg>
  )
}

export function EmptyBellGlyph({ size = 34 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true" focusable="false">
      <path d="M6.5 9a5.5 5.5 0 0 1 11 0c0 6 2.6 8 2.6 8H3.9s2.6-2 2.6-8" {...STROKE} />
      <path d="M13.6 20.2a1.9 1.9 0 0 1-3.2 0" {...STROKE} />
    </svg>
  )
}
